import { z } from 'zod';
export const getWithdrawalHistoryInputSchema = z.object({
    page: z.coerce.number().int().positive().optional().default(1),
    pageSize: z.coerce.number().int().positive().max(100).optional().default(20),
});
export const getWithdrawalHistoryOutputSchema = z.object({
    page: z.number(),
    pageSize: z.number(),
    total: z.number(),
    totalPages: z.number(),
    data: z.array(z.object({
        id: z.string(),
        address: z.string().nullable(),
        amountInCents: z.number(),
        amount: z.number(),
        status: z.string(),
        createdAt: z.date().nullable(),
        updatedAt: z.date().nullable(),
    })),
});
